import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Simple redirect component for Account Connections.
 *
 * This component only appears when React Router tries to handle the /accounts/3rdparty/ route.
 * It performs a native browser navigation to the Django-rendered page.
 */
const AccountConnections: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // If we detect we're in the React app context (not Django template),
    // redirect to the server route with a native browser navigation
    if (!document.querySelector('.socialaccount-section')) {
      // Use replace to avoid creating a history entry
      window.location.replace('/accounts/3rdparty/');
    }
  }, []);

  // Return nothing - this component should never actually render
  return null;
};

export default AccountConnections;
